const rules = {
  'extra-groups': { extras_count: 'group_has_extras' },
  'option-groups': { options_count: 'group_has_options' },
  'menu-groups': { menus_count: 'group_has_menus' },
  'product-groups': { children_count: 'group_has_children', supplier_products_count: 'group_has_supplier_products' },
  warehouses: { children_count: 'warehouse_has_children', shipping_areas_count: 'warehouse_has_shipping_areas', products_count: 'warehouse_has_product_links' },
  'returnable-containers': { components_count: 'container_in_use' },
};
const codes = new Set([
  ...Object.values(rules).flatMap(rule => Object.values(rule)),
  'warehouse_is_default', 'product_is_ingredient', 'cannot_delete_self', 'station_not_ready', 'station_has_assignments',
  'station_type_mismatch', 'station_group_change_blocked',
  'warehouse_has_balance', 'warehouse_has_pending_receipts', 'historical_product_missing', 'restore_source_first',
  'restore_record_missing', 'restore_identity_conflict', 'restore_dependency_first', 'deleted_reference',
  'order_fully_checked', 'order_unit_history_incomplete', 'order_warehouse_balance_missing',
  'order_not_cancelled', 'order_has_active_receipt', 'order_cancellation_incomplete', 'order_restore_unavailable',
  'receipt_closed', 'receipt_cancelled_orders', 'receipt_orders_changed', 'receipt_rebuild_unavailable', 'receipt_rebuild_conflict',
]);

export function knownDeleteBlockers(record, resource) {
  const blockers = new Set(record.delete_blockers || []);
  Object.entries(rules[resource] || {}).forEach(([field, code]) => {
    if (Number(record[field]) > 0) blockers.add(code);
  });
  if (['product-groups', 'warehouses'].includes(resource) && (record.children || []).some(child => !child.is_deleted && !child.deleted_at)) {
    blockers.add(resource === 'warehouses' ? 'warehouse_has_children' : 'group_has_children');
  }
  return [...blockers];
}

export function blockerMessage(vm, code) {
  return vm.$t(codes.has(code) ? `lifecycle.errors.${code}` : 'lifecycle.conflict');
}

export function warehouseRemovalBlocked(record) {
  return ['quantity', 'ordered_quantity'].some(field => Math.abs(Number(record.pivot?.[field] || 0)) > 0.000001);
}

export function lifecycleErrorMessage(vm, error) {
  const data = error.response?.data;
  if (codes.has(data?.code)) return blockerMessage(vm, data.code);
  const status = error.response?.status;
  return vm.$t(status === 403 ? 'lifecycle.forbidden' : status === 404 ? 'lifecycle.not_found'
    : [409, 422].includes(status) ? 'lifecycle.conflict' : 'lifecycle.failed');
}

export function notifyLifecycleError(vm, error) {
  const message = lifecycleErrorMessage(vm, error);
  const method = [409, 422].includes(error.response?.status) ? 'warning' : 'error';
  vm.$toast[method](message);
  return message;
}
